import {Swiper, Navigation, Autoplay } from 'swiper';
Swiper.use([Navigation, Autoplay]);

(function() {

    //MENU MOBILE
    let hamburger = document.querySelector('.hamburger')
	let links = document.querySelectorAll('.header-nav a')

    hamburger.addEventListener('click', (e) => {
        e.preventDefault()
        toggleNav()
    })

	links.forEach((link) => {
		link.addEventListener('click', () => {
			document.querySelector('.hamburger').classList.remove('is-active')
			document.querySelector('.main-header').classList.remove('open')
		});
	});

    function toggleNav() {
        document.querySelector('.hamburger').classList.toggle('is-active')
        document.querySelector('.main-header').classList.toggle('open')
    }

    //HEADER SCROLL
    var doc = document.documentElement;
    var curScroll
    var body = document.body
    var threshold = 0

    var checkScroll = function(e) {
        curScroll = document.body.scrollTop || doc.scrollTop;
        toggleHeader();
    };

    var toggleHeader = function() { 
        if(curScroll > threshold) {
            body.classList.add('scrolled')
        }
        else{
            body.classList.remove('scrolled')
        }
    };

    window.addEventListener('scroll', checkScroll, { passive: true });

    //BOUTON IMPRIMER
    let prints = document.querySelectorAll('.print-btn')
    prints.forEach((print) => {
		print.addEventListener('click', (e) => {
            e.preventDefault()
			window.print()
		});
	});

    //TOGGLE
    let toggles = document.querySelectorAll('.toggle')
    toggles.forEach((toggle) => {
        toggle.children[0].addEventListener('click', (e) => {
            let currentToggle = e.currentTarget.parentNode
            currentToggle.classList.toggle('active')
        })
    });

    //BESOIN D'AIDE FORM
    var data = [
        {
            "name": "BAC STD2A",
            "link": "https://www.esaat-roubaix.com/baccalaureat/",
            "lvl": "brevet",
            "domaine": "tous"
        },
        {
            "name": "DN MADe Cinéma d’animation",
            "link": "https://www.esaat-roubaix.com/cinema-danimation/#dn-made-cinema-animation",
            "lvl": "bac",
            "domaine": "animation"
        },
        {
            "name": "Formation Complémentaire en Cinéma d’animation",
            "link": "https://www.esaat-roubaix.com/cinema-danimation/#formation-cinema-animation",
            "lvl": "licence",
            "domaine": "animation"
        },
        {
            "name": "DSAA mention Espace",
            "link": "https://www.esaat-roubaix.com/design-despace/#dsaa-espace",
            "lvl": "licence",
            "domaine": "espace"
        },
        {
            "name": "DN MADe Espaces Habités",
            "link": "https://www.esaat-roubaix.com/design-despace/#espaces-habites",
            "lvl": "bac",
            "domaine": "espace"
        },
        {
            "name": "DN MADe Espaces Partagés",
            "link": "https://www.esaat-roubaix.com/design-despace/#espaces-partages",
            "lvl": "bac",
            "domaine": "espace"
        },
        {
            "name": "DN MADe Design d’Évènements Commerciaux",
            "link": "https://www.esaat-roubaix.com/design-devenement/#evenements-commerciaux",
            "lvl": "bac",
            "domaine": "evenement"
        },
        {
            "name": "DN MADe Scénographie Culturelle",
            "link": "https://www.esaat-roubaix.com/design-devenement/#scenographie-culturelle",
            "lvl": "bac",
            "domaine": "evenement"
        },
        {
            "name": "DSAA mention Graphisme",
            "link": "https://www.esaat-roubaix.com/design-graphique/#dsaa-graphisme",
            "lvl": "licence",
            "domaine": "graphisme"
        },
        {
            "name": "DN MADe Édition Multisupport",
            "link": "https://www.esaat-roubaix.com/design-graphique/#editions-multisupports",
            "lvl": "bac",
            "domaine": "graphisme"
        },
        {
            "name": "DN MADe Supports Connectés",
            "link": "https://www.esaat-roubaix.com/design-graphique/#supports-connectes",
            "lvl": "bac",
            "domaine": "graphisme"
        },
        {
            "name": "DSAA design mention Produit",
            "link": "https://www.esaat-roubaix.com/design-produit/#dsaa-produit",
            "lvl": "licence",
            "domaine": "produit"
        },
        {
            "name": "DN MADe Design et Société",
            "link": "https://www.esaat-roubaix.com/design-produit/#design-et-societe",
            "lvl": "bac",
            "domaine": "produit"
        },
        {
            "name": "DN MADe Design et Matériaux",
            "link": "https://www.esaat-roubaix.com/design-produit/#design-et-materiaux",
            "lvl": "bac",
            "domaine": "produit"
        },
        {
            "name": "DSAA design mention Textile",
            "link": "https://www.esaat-roubaix.com/design-textile/#dsaa-textile",
            "lvl": "licence",
            "domaine": "textile"
        },
        {
            "name": "DN MADe Textile Couleur Matière",
            "link": "https://www.esaat-roubaix.com/design-textile/#textile-couleur-matiere",
            "lvl": "bac",
            "domaine": "textile"
        },
        {
            "name": "DN MADe Textile Dessin Motif",
            "link": "https://www.esaat-roubaix.com/design-textile/#textile-dessin-motif",
            "lvl": "bac",
            "domaine": "textile"
        }
    ]

    function findFormation(result) {
        if(result.domaine == 'tous' || this.domaine == '') return this.lvl == result.lvl 
        if( this.lvl == '') return this.domaine == result.domaine 
        return this.lvl == result.lvl && this.domaine == result.domaine
    }

    document.addEventListener('input', (event) => {
        if (event.target.id !== 'lvl' && event.target.id !== 'domaine') return;
    
        let selection = {
            lvl: document.getElementById("lvl").value,
            domaine: document.getElementById("domaine").value
        };

        let resultEl = document.querySelector(".result")
        resultEl.innerHTML = '';
        data.filter(findFormation, selection).forEach(element=>{
            let li = document.createElement('li')
            let a = document.createElement('a')
            a.textContent = element.name
            a.href = element.link
            li.appendChild(a)
            resultEl.appendChild(li)
        })

        

    }, false);
    
 })();

 //EFFETS LOGO
document.addEventListener("DOMContentLoaded", () => {
    let currentPoint = document.querySelector('.logo .current')
    Array.from(document.querySelectorAll('.point')).map((element)=>{
        element.addEventListener('mouseover', (e)=>{
            currentPoint.classList.remove('current')
        })
        element.addEventListener('mouseout', (e)=>{
            currentPoint.classList.add('current')
        })
    })
})

const CARROUSEL = new Swiper('.swiper-tile', {
    loop: true,
    speed: 500,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    autoplay: {
        delay: 3000,
    }
})

const SWIPPER_LIST_PAROLES = new Swiper('.swiper-section-paroles', {
    loop: true,
    slidesPerView: 1,
    breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
})

//PARALLAX HOME

function offsetTop(element, acc = 0){
    if(element.offsetParent){
        return offsetTop(element.offsetParent, acc + element.offsetTop)
    }
    return acc + element.offsetTop
}

class Parallax{

    constructor(element){
        this.element = element
        this.ratio = -0.3
        this.onScroll = this.onScroll.bind(this)
        document.addEventListener('scroll', this.onScroll)
    }

    onScroll(){
        const screenY = window.scrollY + window.innerHeight/2
        const elementY = offsetTop(this.element) + this.element.offsetHeight / 2
        const diffY = elementY - screenY
        this.element.style.setProperty('transform', `translateY(${diffY*-1*this.ratio}px)`) 
    }

}

Array.from(document.querySelectorAll('.banniere-parallax h2')).map((element) =>{
    new Parallax(element)
})
